import isEmpty from 'lodash/isEmpty';

import {
  BLOCK_OBJECT,
  TEXT_OBJECT,
  INLINE_OBJECT,
  MARK_OBJECT,
} from './constants';

const emptyNode = () => [
  {
    text: '',
  },
];

const serializationHelpers = {
  extractChildren: ({ node }) => {
    // TODO NEEDS TO BE FIXED
    if (node.object === TEXT_OBJECT && !!node.children) {
      return node.children;
    }

    if (node.type === TEXT_OBJECT || node.type === undefined) {
      return [node];
    }

    return node.children;
  },
  // This method looks for inline nodes, and then convert them to a mark
  normalizeInlinesChildren: ({ children }) => {
    let normalizedNodes = [];

    children.forEach((child) => {
      const nestedChildren = child.children;
      if (nestedChildren) {
        nestedChildren.forEach((nestedChild) => {
          normalizedNodes.push({
            ...nestedChild,
            type: child.type,
            data: child.data,
            [child.type]: true,
          });
        });
      } else {
        normalizedNodes.push(child);
      }
    });

    return [
      {
        children: normalizedNodes,
        object: TEXT_OBJECT,
      },
    ];
  },
  matchBlock: ({ node, match }) =>
    node.type === match.type ||
    (node.object === BLOCK_OBJECT && node.type === match.type),
  matchText: ({ node }) =>
    node.text !== undefined || node.object === TEXT_OBJECT,
  matchInline: ({ node }) => node.object === INLINE_OBJECT,
  matchMark: ({ node, match }) =>
    node.object === MARK_OBJECT && node.type === match.type,
  createBlock: ({ node, definitions, children = [] }) => ({
    [`${definitions.__typename}`]: children.length > 0 ? children[0] : {},
  }),
  createText: ({ children: { text, marks: markups } }) => {
    if (markups.length > 0) {
      return {
        text,
        markups,
      };
    }
    return {
      text,
    };
  },
  createMark: ({ node, definitions, data }) => {
    const { start, end } = node;

    return {
      __typename: definitions.type,
      start,
      end,
      ...data,
    };
  },
};

const deserializationHelpers = {
  extractChildren: ({ node }) => {
    if (node.object === TEXT_OBJECT) {
      return node;
    }
    const { __typename, ...restOfAttributes } = node;
    return [{ object: TEXT_OBJECT, ...restOfAttributes }];
  },
  // this method converts inlines into a serialized mark
  normalizeInlinesChildren: ({ children }) => {
    if (
      isEmpty(children) ||
      (children && Array.isArray(children[0]) && !children[0].length)
    ) {
      return emptyNode();
    }
    return children;
  },
  matchBlock: ({ node, match }) => node.__typename === match.__typename,
  matchText: ({ node }) => node.object === TEXT_OBJECT,
  matchMark: ({ node, match }) => node.__typename === match.__typename,
  createBlock: ({ node, definitions, children = [], data = {} }) => {
    const nodes = children.length > 0 ? children : emptyNode();
    const isDataEmpty = isEmpty(data);

    return isDataEmpty
      ? { type: definitions.type, children: nodes }
      : {
          type: definitions.type,
          children: nodes,
          data,
        };
  },
  createText: ({ children }) => children,
  createMark: ({ node: { start, end }, definitions, data = {} }) => ({
    [definitions.type]: !!definitions.type,
    data,
    end,
    start,
    type: definitions.type,
  }),
};

export { serializationHelpers, deserializationHelpers, emptyNode };
